import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { ScreenSizeService } from 'src/app/services/screen-size.service';
import { StorageService } from 'src/app/services/storage.service';

@Component({
  selector: 'app-menu-modal',
  templateUrl: './menu-modal.component.html',
  styleUrls: ['./menu-modal.component.scss'],
})
export class MenuModalComponent implements OnInit {
  mobileSize: boolean = false;
  loggedIn: boolean = false;
  urlPath: any;
  userObj: any;
  menuToggle: boolean = false;
  showCase: boolean = false;
  access_token: string;
  constructor(private _screenSize: ScreenSizeService,
    private router: Router,
    private strg: StorageService,
    private authService: AuthenticationService,
    private ModalControl: ModalController
  ) {
    this._screenSize.checkScreenSize().subscribe(res => {
      if (res === "sizeXS" || res === "sizeSM") {
        this.mobileSize = true;
      } else {
        this.mobileSize = false;
      }
    });
    this.authService.authState.subscribe(res => { this.loggedIn = res; });

    this.strg.getStoreData("userObj").then(res => {
      this.userObj = res;
    });

    this.strg.getStoreData("insAccessToken").then(res => {
      this.access_token = res;
    });
  }

  ngOnInit() {
    this.urlPath = this.router.url;
  }
  landingClicked() {
    window.open("https://www.mypolicyjunction.com/index.html", "_self");
  }
  quoteClicked() {
    window.open("https://www.mypolicyjunction.com/termins.html", "_self");
  }
  claimClicked() {
    window.open("https://www.mypolicyjunction.com/claim.html", "_self");
  }
  insuranceClicked() {
    window.open("https://www.mypolicyjunction.com/index.html", "_self");
  }
  homeClicked() {
    this.router.navigate(['/home/dashboard']);
  }

  signInClicked() {
    this.router.navigate(['/login']);
  }

  signUpClicked() {
    this.router.navigate(['/register']);
  }
  renewalClicked() {
    window.open("https://mypolicyjunction.com/renewal.html");
  }
  logoutClicked() {
    this.authService.revokeAuthTokenOnLogout(this.access_token, this.userObj.id).subscribe(ress => {
      this.strg.removeStoreData("insAccessToken").then(res => {
        this.strg.removeStoreData("insRefreshToken").then(res => {
          this.strg.removeStoreData("userObj").then(res => {
            this.authService.authState.next(false);
            // this.router.navigate(['/login']);
            this.router.navigate(['login'], { queryParams: { returnUrl: this.router.url } });
            this.loggedIn = this.authService.isAuthenticated();
          });
        });
      });
    });
  }
  dismiss() {
    // using the injected ModalController this page
    // can "dismiss" itself and optionally pass back data
    this.ModalControl.dismiss({
      'dismissed': true
    });
  }

  tempNo = 0;

  showToggs() {
    if (this.tempNo === 0) {
      this.showCase = true;
      this.tempNo = 1;
    }
    else {
      this.showCase = false;
      this.tempNo=0;
    }
  }

}
